module.exports = __webpack_public_path__ + "static/media/mobility-brikk-preview.0f38574f.png";